import type {DefaultOptions} from '../../../types';
import type {MarkdownValueEditorLocalizations, MarkdownValueEditorOptions} from './types';

export const MARKDOWN_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<MarkdownValueEditorOptions> = {
    inline: false
};

export const MARKDOWN_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<MarkdownValueEditorLocalizations>({
    description: '',
    emptyValue: 'empty formatted text',
    editValue: 'Edit formatted text'
});